import React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import InputText from 'FormInputs/InputText/InputText';
import Labels from '../../enums/Labels';

const InputGP = (): React.ReactElement => (
  <Field name="gpName">
    {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
      <InputText
        labelWrapperClass="form-input"
        label={Labels.PERSONAL_DETAILS_YOUR_DOCTOR}
        placeholder={Labels.PERSONAL_DETAILS_YOUR_DOCTOR}
        input={input}
        meta={meta}
        isRequired={true}
      />
    )}
  </Field>
);
export default InputGP;
